import { render } from "./App.vue?vue&type=template&id=43cac1e8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=43cac1e8&lang=css"

import exportComponent from "/Users/konstantinkorobitsin/Work/vr-local-web-player/vr-player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__